export default __webpack_public_path__ + "c2fd238ac129e45d099aadb3b66a5145.png";